import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import GlobalStyles from '@mui/material/GlobalStyles';

import {AuthGuard} from 'components/auth/auth-guard';
import {MainNav} from 'components/core/layout/main-nav';
import {navItems} from "components/client/layout/config";
import {SideNav} from "components/core/layout/side-nav";
import {Outlet} from "react-router";
import {OrganisationProvider} from "../../contexts/organisation-context";

export default function ClientLayout(): React.JSX.Element {
  return (
    <AuthGuard>
      <OrganisationProvider>
        <GlobalStyles
          styles={{
            body: {
              '--MainNav-height': '56px',
              '--MainNav-zIndex': 1000,
              '--SideNav-width': '280px',
              '--SideNav-zIndex': 1100,
              '--MobileNav-width': '320px',
              '--MobileNav-zIndex': 1100,
            },
          }}
        />
        <Box
          sx={{
            bgcolor: 'var(--mui-palette-background-default)',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            minHeight: '100%',
          }}
        >
          <SideNav items={navItems} includeOrganisationSelector={true}/>
          <Box sx={{display: 'flex', flex: '1 1 auto', flexDirection: 'column', pl: {lg: 'var(--SideNav-width)'}}}>
            <MainNav items={navItems} includeOrganisationSelector={true}/>
            <main>
              <Container maxWidth="xl" sx={{py: '32px'}}>
                <Outlet/>
              </Container>
            </main>
          </Box>
        </Box>
      </OrganisationProvider>
    </AuthGuard>
  );
}
